import { View, Utils } from '../vendor/kerneljs';


const Overlay = View.extend({
	viewName:'Overlay',
	className: 'overlay overlay--modal',

	events: {
		'click': 'onClick'
	},

	initialize: function(){
		this.bodyRef = Utils.find('body')[0];

		this.htmlRef = Utils.find('html')[0];

		if ( this.settings.fixBody ) Utils.addClass(this.bodyRef,'is-fixed');
		if ( this.settings.isBlurred ) Utils.addClass(this.bodyRef,'is-blurred');
		if ( this.settings.isFixed ) this.addClass('overlay--fixed');
		if ( this.settings.whiteBg ) this.addClass('overlay--white');

		this.eventEmitter.on('modal:close', this.close.bind(this));

		Utils.on(window, 'modal:render', this.newModalRendered.bind(this));

	},
	render: function() {
		Utils.append(this.bodyRef, this.el);

		setTimeout(function(){
			this.addClass('is-active');
			this.rendered = true;

		}.bind(this), 1);

		Utils.addClass(this.htmlRef,'is-modal-mode');
	},

	onClick: function(e){
		if(e.target !== this.el) { return false; }

		e.stopPropagation();
		e.preventDefault();
		this.eventEmitter.emit('overlay:clicked', e);
		this.close();
	},

	newModalRendered: function() {
		if (this.rendered) this.close();
	},

	close:function() {
		Utils.removeClass(this.htmlRef,'is-modal-mode');

		Utils.removeClass(this.bodyRef,'is-fixed');
		Utils.removeClass(this.bodyRef,'is-blurred');
		this.remove();


		let modalEvent = EventProxy('modal:close');
		window.dispatchEvent(modalEvent);
	}
});

export default Overlay;